import { render, staticRenderFns } from "./pageElementColorpicker.vue?vue&type=template&id=bed87502&"
import script from "./pageElementColorpicker.vue?vue&type=script&lang=js&"
export * from "./pageElementColorpicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports